export const BundleDiscountBanner = () => {
    return (
        <div className="mb-4">
            <div
                className='flex items-center h-[48px] rounded-[6px] overflow-hidden md:w-full md:max-w-[320px] max-w-full'
                style={{
                    background: '#FFE03C',
                }}
            >
                <div className='flex items-center w-full px-[12px]'>
                    <div className='flex items-center w-full justify-between '>
                        <div className='bg-[#FF0099] rounded-full px-[9px] py-[5px] min-w-[80px] text-center'>
                            <p className='font-medium text-[14px] text-white'>40% Off</p>
                        </div>

                        <div className='ml-2'>
                            <p className='font-medium text-[#2A2A2A] text-[14px] font-graphik tracking-[-0.14px]'>
                                {`All extra pairs`}
                            </p>
                        </div>

                        <div className="bg-[#959595] w-[1px] h-[22px]"></div>

                        <div className='flex items-center justify-center '>
                            <p className='text-[#616161] text-[11px] font-graphik font-normal'>
                                Discount applied<br /> at checkout.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div >
    );
}; 